/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import { useIsDesktop } from '@cian/valuation-utils-component';
import { OtherServices, TitleServices } from '../../components/Services';
import { EJournalSidebarServices } from '../../types/services';
import { JournalSidebarItem, JournalSidebarLayout } from '../../components/JournalSidebar';
import { useSelector } from 'react-redux';
import { JournalSidebarContainer } from './JournalSidebarContainer';
import { selectMyHomeId } from '../../selectors/selectMyHomeId';
import {
  trackJournalAdvicesClick,
  trackJournalDocumentsClick,
  trackJournalRentClick,
  trackJournalSaleClick,
} from './tracking';

const serviceToUrlMapper = {
  [EJournalSidebarServices.experts]: 'https://www.cian.ru/magazine-pomoshnik-po-nedvizhimosti/',
  [EJournalSidebarServices.documents]: 'https://www.cian.ru/stati-tipovye-dogovory-vse-shablony-306977/',
  [EJournalSidebarServices.sale]: 'https://www.cian.ru/guide/prodat-kvartiru-vtorichka/',
  [EJournalSidebarServices.rent]: 'https://www.cian.ru/guide/prodat-kvartiru-vtorichka/?dealType=rent',
};

export const JournalSidebarLoader: React.FC = () => {
  const isDesktop = useIsDesktop();

  const myHomeId = useSelector(selectMyHomeId);

  const getTrackFn = React.useCallback(
    (serviceType: EJournalSidebarServices): any => {
      switch (serviceType) {
        case EJournalSidebarServices.sale:
          return trackJournalSaleClick;
        case EJournalSidebarServices.rent:
          return trackJournalRentClick;
        case EJournalSidebarServices.documents:
          return trackJournalDocumentsClick;
        case EJournalSidebarServices.experts:
          return trackJournalAdvicesClick;
      }
    },
    [trackJournalSaleClick, trackJournalRentClick],
  );

  const handleClick = React.useCallback(
    (serviceType: EJournalSidebarServices) => {
      const trackFn = getTrackFn(serviceType);
      trackFn();

      window.open(serviceToUrlMapper[serviceType], '_blank');
    },
    [myHomeId],
  );

  return (
    <JournalSidebarContainer isDesktop={isDesktop}>
      {isDesktop && <TitleServices title="Ваш гид по недвижимости" />}

      <JournalSidebarLayout>
        <JournalSidebarItem
          title="Как быстро продать квартиру"
          img="img-sale"
          onClick={() => handleClick(EJournalSidebarServices.sale)}
        />

        <JournalSidebarItem
          title="Как выгодно сдать квартиру"
          img="img-rent"
          onClick={() => handleClick(EJournalSidebarServices.rent)}
        />
      </JournalSidebarLayout>

      <OtherServices
        title="Советы экспертов"
        description="Редакционные материалы и личные блоги профессионалов"
        img="img-experts"
        onClick={() => handleClick(EJournalSidebarServices.experts)}
        // Необходимый хардкод - потому что для мобилки ссылки открываются в модалке
        isDesktop={true}
        isSmallDescription={!isDesktop}
      />

      <OtherServices
        title="Шаблоны документов"
        description="Договоры, акты, извещения, соглашения, расписки"
        img="img-documents"
        onClick={() => handleClick(EJournalSidebarServices.documents)}
        // Необходимый хардкод - потому что для мобилки ссылки открываются в модалке
        isDesktop={true}
        isSmallDescription={!isDesktop}
      />
    </JournalSidebarContainer>
  );
};
